/* unplugin-vue-components disabled */import script from "./SimpleActionSheet.vue?vue&type=script&lang=ts&setup=true"
export * from "./SimpleActionSheet.vue?vue&type=script&lang=ts&setup=true"

import "./SimpleActionSheet.vue?vue&type=style&index=0&id=4977cf09&lang=scss"

const __exports__ = script;

export default __exports__